/**
 * Thread import data from CSV
 * This file contains all 412 Madeira Polyneon threads ready for import
 */

export const threadsData = [
  { threadNumber: "1500", hexCode: "#202448", brand: "Madeira Polyneon" },
  { threadNumber: "1502", hexCode: "#737B82", brand: "Madeira Polyneon" },
  { threadNumber: "1505", hexCode: "#A7ADB2", brand: "Madeira Polyneon" },
  { threadNumber: "1506", hexCode: "#34424E", brand: "Madeira Polyneon" },
  { threadNumber: "1507", hexCode: "#242F38", brand: "Madeira Polyneon" },
  { threadNumber: "1508", hexCode: "#E594AA", brand: "Madeira Polyneon" },
  { threadNumber: "1509", hexCode: "#B6253E", brand: "Madeira Polyneon" },
  { threadNumber: "1521", hexCode: "#CF703A", brand: "Madeira Polyneon" },
  { threadNumber: "1522", hexCode: "#7776C0", brand: "Madeira Polyneon" },
  { threadNumber: "1526", hexCode: "#F8DF99", brand: "Madeira Polyneon" },
  { threadNumber: "1527", hexCode: "#C49C6E", brand: "Madeira Polyneon" },
  { threadNumber: "1528", hexCode: "#4697D2", brand: "Madeira Polyneon" },
  { threadNumber: "1529", hexCode: "#C3C0D2", brand: "Madeira Polyneon" },
  { threadNumber: "1531", hexCode: "#5481B5", brand: "Madeira Polyneon" },
  { threadNumber: "1532", hexCode: "#78AAE5", brand: "Madeira Polyneon" },
  { threadNumber: "1535", hexCode: "#9D917B", brand: "Madeira Polyneon" },
  { threadNumber: "1538", hexCode: "#A98D5F", brand: "Madeira Polyneon" },
  { threadNumber: "1539", hexCode: "#5C5B56", brand: "Madeira Polyneon" },
  { threadNumber: "1540", hexCode: "#3D4242", brand: "Madeira Polyneon" },
  { threadNumber: "1541", hexCode: "#E5E871", brand: "Madeira Polyneon" },
  { threadNumber: "1542", hexCode: "#6992BD", brand: "Madeira Polyneon" },
  { threadNumber: "1544", hexCode: "#51606E", brand: "Madeira Polyneon" },
  { threadNumber: "1545", hexCode: "#D6F0E9", brand: "Madeira Polyneon" },
  { threadNumber: "1548", hexCode: "#FF9FC4", brand: "Madeira Polyneon" },
  { threadNumber: "1549", hexCode: "#FCBFDC", brand: "Madeira Polyneon" },
  { threadNumber: "1550", hexCode: "#BCD4F0", brand: "Madeira Polyneon" },
  { threadNumber: "1552", hexCode: "#B2AB63", brand: "Madeira Polyneon" },
  { threadNumber: "1553", hexCode: "#3E3E5F", brand: "Madeira Polyneon" },
  { threadNumber: "1554", hexCode: "#ECD7CE", brand: "Madeira Polyneon" },
  { threadNumber: "1555", hexCode: "#1E2538", brand: "Madeira Polyneon" },
  { threadNumber: "1556", hexCode: "#CCA178", brand: "Madeira Polyneon" },
  { threadNumber: "1557", hexCode: "#393227", brand: "Madeira Polyneon" },
  { threadNumber: "1558", hexCode: "#352924", brand: "Madeira Polyneon" },
  { threadNumber: "1559", hexCode: "#36302A", brand: "Madeira Polyneon" },
  { threadNumber: "1560", hexCode: "#2A2722", brand: "Madeira Polyneon" },
  { threadNumber: "1561", hexCode: "#F9E79F", brand: "Madeira Polyneon" },
  { threadNumber: "1562", hexCode: "#97BCD9", brand: "Madeira Polyneon" },
  { threadNumber: "1563", hexCode: "#C6E3F3", brand: "Madeira Polyneon" },
  { threadNumber: "1564", hexCode: "#414A4F", brand: "Madeira Polyneon" },
  { threadNumber: "1565", hexCode: "#613C1C", brand: "Madeira Polyneon" },
  { threadNumber: "1566", hexCode: "#17387F", brand: "Madeira Polyneon" },
  { threadNumber: "1567", hexCode: "#572127", brand: "Madeira Polyneon" },
  { threadNumber: "1568", hexCode: "#8F8D69", brand: "Madeira Polyneon" },
  { threadNumber: "1569", hexCode: "#63674A", brand: "Madeira Polyneon" },
  { threadNumber: "1572", hexCode: "#919498", brand: "Madeira Polyneon" },
  { threadNumber: "1573", hexCode: "#A79885", brand: "Madeira Polyneon" },
  { threadNumber: "1574", hexCode: "#212A33", brand: "Madeira Polyneon" },
  { threadNumber: "1575", hexCode: "#606E71", brand: "Madeira Polyneon" },
  { threadNumber: "1577", hexCode: "#0095B4", brand: "Madeira Polyneon" },
  { threadNumber: "1578", hexCode: "#78A292", brand: "Madeira Polyneon" },
  { threadNumber: "1580", hexCode: "#096F50", brand: "Madeira Polyneon" },
  { threadNumber: "1582", hexCode: "#E4E0CB", brand: "Madeira Polyneon" },
  { threadNumber: "1584", hexCode: "#CE4E7E", brand: "Madeira Polyneon" },
  { threadNumber: "1588", hexCode: "#D5392C", brand: "Madeira Polyneon" },
  { threadNumber: "1589", hexCode: "#2A3134", brand: "Madeira Polyneon" },
  { threadNumber: "1592", hexCode: "#D1EDED", brand: "Madeira Polyneon" },
  { threadNumber: "1593", hexCode: "#1198CA", brand: "Madeira Polyneon" },
  { threadNumber: "1594", hexCode: "#54C3D7", brand: "Madeira Polyneon" },
  { threadNumber: "1595", hexCode: "#FF3C78", brand: "Madeira Polyneon" },
  { threadNumber: "1596", hexCode: "#E42D73", brand: "Madeira Polyneon" },
  { threadNumber: "1597", hexCode: "#FF5E96", brand: "Madeira Polyneon" },
  { threadNumber: "1598", hexCode: "#FF5500", brand: "Madeira Polyneon" },
  { threadNumber: "1599", hexCode: "#92FF31", brand: "Madeira Polyneon" },
  { threadNumber: "1610", hexCode: "#C4D0D2", brand: "Madeira Polyneon" },
  { threadNumber: "1611", hexCode: "#A5B2BE", brand: "Madeira Polyneon" },
  { threadNumber: "1612", hexCode: "#93A9BC", brand: "Madeira Polyneon" },
  { threadNumber: "1613", hexCode: "#8F9FA0", brand: "Madeira Polyneon" },
  { threadNumber: "1614", hexCode: "#555D5C", brand: "Madeira Polyneon" },
  { threadNumber: "1615", hexCode: "#67706F", brand: "Madeira Polyneon" },
  { threadNumber: "1616", hexCode: "#D96D68", brand: "Madeira Polyneon" },
  { threadNumber: "1617", hexCode: "#4A4855", brand: "Madeira Polyneon" },
  { threadNumber: "1618", hexCode: "#676F7B", brand: "Madeira Polyneon" },
  { threadNumber: "1619", hexCode: "#575C65", brand: "Madeira Polyneon" },
  { threadNumber: "1620", hexCode: "#FE919A", brand: "Madeira Polyneon" },
  { threadNumber: "1621", hexCode: "#B8521C", brand: "Madeira Polyneon" },
  { threadNumber: "1622", hexCode: "#FCF2C5", brand: "Madeira Polyneon" },
  { threadNumber: "1623", hexCode: "#FFF13A", brand: "Madeira Polyneon" },
  { threadNumber: "1624", hexCode: "#FFC200", brand: "Madeira Polyneon" },
  { threadNumber: "1625", hexCode: "#DEA429", brand: "Madeira Polyneon" },
  { threadNumber: "1626", hexCode: "#D5760C", brand: "Madeira Polyneon" },
  { threadNumber: "1627", hexCode: "#6D6B83", brand: "Madeira Polyneon" },
  { threadNumber: "1628", hexCode: "#78A6C6", brand: "Madeira Polyneon" },
  { threadNumber: "1629", hexCode: "#CBD3F0", brand: "Madeira Polyneon" },
  { threadNumber: "1630", hexCode: "#9797C9", brand: "Madeira Polyneon" },
  { threadNumber: "1631", hexCode: "#8460A2", brand: "Madeira Polyneon" },
  { threadNumber: "1632", hexCode: "#2B263C", brand: "Madeira Polyneon" },
  { threadNumber: "1633", hexCode: "#4C1E59", brand: "Madeira Polyneon" },
  { threadNumber: "1634", hexCode: "#2F2952", brand: "Madeira Polyneon" },
  { threadNumber: "1635", hexCode: "#5F2839", brand: "Madeira Polyneon" },
  { threadNumber: "1637", hexCode: "#AC211C", brand: "Madeira Polyneon" },
  { threadNumber: "1638", hexCode: "#782423", brand: "Madeira Polyneon" },
  { threadNumber: "1639", hexCode: "#9D3530", brand: "Madeira Polyneon" },
  { threadNumber: "1640", hexCode: "#555C5D", brand: "Madeira Polyneon" },
  { threadNumber: "1641", hexCode: "#222B2D", brand: "Madeira Polyneon" },
  { threadNumber: "1642", hexCode: "#2C5496", brand: "Madeira Polyneon" },
  { threadNumber: "1643", hexCode: "#1C2833", brand: "Madeira Polyneon" },
  { threadNumber: "1645", hexCode: "#79CEC2", brand: "Madeira Polyneon" },
  { threadNumber: "1647", hexCode: "#90C2A1", brand: "Madeira Polyneon" },
  { threadNumber: "1648", hexCode: "#879D5A", brand: "Madeira Polyneon" },
  { threadNumber: "1649", hexCode: "#709616", brand: "Madeira Polyneon" },
  { threadNumber: "1650", hexCode: "#306E25", brand: "Madeira Polyneon" },
  { threadNumber: "1651", hexCode: "#007E3B", brand: "Madeira Polyneon" },
  { threadNumber: "1652", hexCode: "#38706F", brand: "Madeira Polyneon" },
  { threadNumber: "1653", hexCode: "#F9C7AD", brand: "Madeira Polyneon" },
  { threadNumber: "1654", hexCode: "#56463F", brand: "Madeira Polyneon" },
  { threadNumber: "1656", hexCode: "#BF9E86", brand: "Madeira Polyneon" },
  { threadNumber: "1657", hexCode: "#785336", brand: "Madeira Polyneon" },
  { threadNumber: "1658", hexCode: "#6F3E2A", brand: "Madeira Polyneon" },
  { threadNumber: "1659", hexCode: "#422E25", brand: "Madeira Polyneon" },
  { threadNumber: "1660", hexCode: "#B2AAA6", brand: "Madeira Polyneon" },
  { threadNumber: "1661", hexCode: "#FFFDD4", brand: "Madeira Polyneon" },
  { threadNumber: "1662", hexCode: "#827E6E", brand: "Madeira Polyneon" },
  { threadNumber: "1663", hexCode: "#5F5A4A", brand: "Madeira Polyneon" },
  { threadNumber: "1664", hexCode: "#4B4E47", brand: "Madeira Polyneon" },
  { threadNumber: "1665", hexCode: "#363B33", brand: "Madeira Polyneon" },
  { threadNumber: "1666", hexCode: "#FFF5B8", brand: "Madeira Polyneon" },
  { threadNumber: "1668", hexCode: "#5A6D5E", brand: "Madeira Polyneon" },
  { threadNumber: "1669", hexCode: "#313F33", brand: "Madeira Polyneon" },
  { threadNumber: "1670", hexCode: "#D6AD5C", brand: "Madeira Polyneon" },
  { threadNumber: "1671", hexCode: "#517EA5", brand: "Madeira Polyneon" },
  { threadNumber: "1672", hexCode: "#9B7329", brand: "Madeira Polyneon" },
  { threadNumber: "1673", hexCode: "#A98E53", brand: "Madeira Polyneon" },
  { threadNumber: "1674", hexCode: "#96C5EF", brand: "Madeira Polyneon" },
  { threadNumber: "1675", hexCode: "#82B7E9", brand: "Madeira Polyneon" },
  { threadNumber: "1676", hexCode: "#2A4487", brand: "Madeira Polyneon" },
  { threadNumber: "1677", hexCode: "#093C3F", brand: "Madeira Polyneon" },
  { threadNumber: "1678", hexCode: "#E75212", brand: "Madeira Polyneon" },
  { threadNumber: "1680", hexCode: "#4B3250", brand: "Madeira Polyneon" },
  { threadNumber: "1681", hexCode: "#AC2D44", brand: "Madeira Polyneon" },
  { threadNumber: "1682", hexCode: "#D4C9B2", brand: "Madeira Polyneon" },
  { threadNumber: "1683", hexCode: "#FFC938", brand: "Madeira Polyneon" },
  { threadNumber: "1684", hexCode: "#C1A96F", brand: "Madeira Polyneon" },
  { threadNumber: "1685", hexCode: "#008E8A", brand: "Madeira Polyneon" },
  { threadNumber: "1686", hexCode: "#DCE1E1", brand: "Madeira Polyneon" },
  { threadNumber: "1687", hexCode: "#B9C4C4", brand: "Madeira Polyneon" },
  { threadNumber: "1689", hexCode: "#606460", brand: "Madeira Polyneon" },
  { threadNumber: "1690", hexCode: "#14403E", brand: "Madeira Polyneon" },
  { threadNumber: "1692", hexCode: "#A2CFCE", brand: "Madeira Polyneon" },
  { threadNumber: "1694", hexCode: "#1A9FB2", brand: "Madeira Polyneon" },
  { threadNumber: "1695", hexCode: "#0081A1", brand: "Madeira Polyneon" },
  { threadNumber: "1701", hexCode: "#489D20", brand: "Madeira Polyneon" },
  { threadNumber: "1702", hexCode: "#79CB89", brand: "Madeira Polyneon" },
  { threadNumber: "1703", hexCode: "#0F4E32", brand: "Madeira Polyneon" },
  { threadNumber: "1704", hexCode: "#15382D", brand: "Madeira Polyneon" },
  { threadNumber: "1705", hexCode: "#293326", brand: "Madeira Polyneon" },
  { threadNumber: "1706", hexCode: "#898138", brand: "Madeira Polyneon" },
  { threadNumber: "1707", hexCode: "#B94148", brand: "Madeira Polyneon" },
  { threadNumber: "1709", hexCode: "#C33C95", brand: "Madeira Polyneon" },
  { threadNumber: "1710", hexCode: "#8A296B", brand: "Madeira Polyneon" },
  { threadNumber: "1711", hexCode: "#A190BA", brand: "Madeira Polyneon" },
  { threadNumber: "1712", hexCode: "#A276A9", brand: "Madeira Polyneon" },
  { threadNumber: "1713", hexCode: "#FEDDDE", brand: "Madeira Polyneon" },
  { threadNumber: "1718", hexCode: "#99A5AD", brand: "Madeira Polyneon" },
  { threadNumber: "1719", hexCode: "#583255", brand: "Madeira Polyneon" },
  { threadNumber: "1720", hexCode: "#512A4B", brand: "Madeira Polyneon" },
  { threadNumber: "1721", hexCode: "#E75F8E", brand: "Madeira Polyneon" },
  { threadNumber: "1722", hexCode: "#362D77", brand: "Madeira Polyneon" },
  { threadNumber: "1723", hexCode: "#FFDDA5", brand: "Madeira Polyneon" },
  { threadNumber: "1724", hexCode: "#DCAD1E", brand: "Madeira Polyneon" },
  { threadNumber: "1725", hexCode: "#C27F11", brand: "Madeira Polyneon" },
  { threadNumber: "1726", hexCode: "#AB7B4B", brand: "Madeira Polyneon" },
  { threadNumber: "1727", hexCode: "#F7E068", brand: "Madeira Polyneon" },
  { threadNumber: "1728", hexCode: "#968369", brand: "Madeira Polyneon" },
  { threadNumber: "1729", hexCode: "#907663", brand: "Madeira Polyneon" },
  { threadNumber: "1730", hexCode: "#6D542A", brand: "Madeira Polyneon" },
  { threadNumber: "1731", hexCode: "#977C93", brand: "Madeira Polyneon" },
  { threadNumber: "1733", hexCode: "#3C78B7", brand: "Madeira Polyneon" },
  { threadNumber: "1734", hexCode: "#D32E2F", brand: "Madeira Polyneon" },
  { threadNumber: "1735", hexCode: "#FDDE50", brand: "Madeira Polyneon" },
  { threadNumber: "1736", hexCode: "#888274", brand: "Madeira Polyneon" },
  { threadNumber: "1738", hexCode: "#CEC09C", brand: "Madeira Polyneon" },
  { threadNumber: "1739", hexCode: "#393A39", brand: "Madeira Polyneon" },
  { threadNumber: "1740", hexCode: "#6C6F73", brand: "Madeira Polyneon" },
  { threadNumber: "1741", hexCode: "#727572", brand: "Madeira Polyneon" },
  { threadNumber: "1742", hexCode: "#183556", brand: "Madeira Polyneon" },
  { threadNumber: "1743", hexCode: "#20294D", brand: "Madeira Polyneon" },
  { threadNumber: "1744", hexCode: "#524739", brand: "Madeira Polyneon" },
  { threadNumber: "1745", hexCode: "#6E594C", brand: "Madeira Polyneon" },
  { threadNumber: "1746", hexCode: "#2DA19C", brand: "Madeira Polyneon" },
  { threadNumber: "1747", hexCode: "#931C23", brand: "Madeira Polyneon" },
  { threadNumber: "1748", hexCode: "#B2EB6F", brand: "Madeira Polyneon" },
  { threadNumber: "1749", hexCode: "#3B9D37", brand: "Madeira Polyneon" },
  { threadNumber: "1750", hexCode: "#006C45", brand: "Madeira Polyneon" },
  { threadNumber: "1751", hexCode: "#007742", brand: "Madeira Polyneon" },
  { threadNumber: "1752", hexCode: "#FEB180", brand: "Madeira Polyneon" },
  { threadNumber: "1753", hexCode: "#B96D3A", brand: "Madeira Polyneon" },
  { threadNumber: "1754", hexCode: "#D63C3E", brand: "Madeira Polyneon" },
  { threadNumber: "1755", hexCode: "#FC9935", brand: "Madeira Polyneon" },
  { threadNumber: "1756", hexCode: "#4C4E1D", brand: "Madeira Polyneon" },
  { threadNumber: "1757", hexCode: "#574A23", brand: "Madeira Polyneon" },
  { threadNumber: "1758", hexCode: "#553B22", brand: "Madeira Polyneon" },
  { threadNumber: "1759", hexCode: "#847025", brand: "Madeira Polyneon" },
  { threadNumber: "1760", hexCode: "#426879", brand: "Madeira Polyneon" },
  { threadNumber: "1761", hexCode: "#89AABC", brand: "Madeira Polyneon" },
  { threadNumber: "1762", hexCode: "#184B62", brand: "Madeira Polyneon" },
  { threadNumber: "1763", hexCode: "#D6821E", brand: "Madeira Polyneon" },
  { threadNumber: "1764", hexCode: "#203B52", brand: "Madeira Polyneon" },
  { threadNumber: "1765", hexCode: "#E46C00", brand: "Madeira Polyneon" },
  { threadNumber: "1766", hexCode: "#29327D", brand: "Madeira Polyneon" },
  { threadNumber: "1767", hexCode: "#1C316E", brand: "Madeira Polyneon" },
  { threadNumber: "1768", hexCode: "#AABE7B", brand: "Madeira Polyneon" },
  { threadNumber: "1769", hexCode: "#526D1E", brand: "Madeira Polyneon" },
  { threadNumber: "1770", hexCode: "#416B31", brand: "Madeira Polyneon" },
  { threadNumber: "1771", hexCode: "#D29406", brand: "Madeira Polyneon" },
  { threadNumber: "1772", hexCode: "#F5AA0C", brand: "Madeira Polyneon" },
  { threadNumber: "1773", hexCode: "#9A5819", brand: "Madeira Polyneon" },
  { threadNumber: "1775", hexCode: "#3E749A", brand: "Madeira Polyneon" },
  { threadNumber: "1776", hexCode: "#1D4461", brand: "Madeira Polyneon" },
  { threadNumber: "1777", hexCode: "#F08675", brand: "Madeira Polyneon" },
  { threadNumber: "1778", hexCode: "#DC5422", brand: "Madeira Polyneon" },
  { threadNumber: "1779", hexCode: "#B74C3C", brand: "Madeira Polyneon" },
  { threadNumber: "1780", hexCode: "#006650", brand: "Madeira Polyneon" },
  { threadNumber: "1781", hexCode: "#831B2A", brand: "Madeira Polyneon" },
  { threadNumber: "1782", hexCode: "#6B2733", brand: "Madeira Polyneon" },
  { threadNumber: "1783", hexCode: "#73234B", brand: "Madeira Polyneon" },
  { threadNumber: "1784", hexCode: "#5E1E28", brand: "Madeira Polyneon" },
  { threadNumber: "1785", hexCode: "#562235", brand: "Madeira Polyneon" },
  { threadNumber: "1786", hexCode: "#A22744", brand: "Madeira Polyneon" },
  { threadNumber: "1787", hexCode: "#A22B5F", brand: "Madeira Polyneon" },
  { threadNumber: "1788", hexCode: "#672860", brand: "Madeira Polyneon" },
  { threadNumber: "1789", hexCode: "#52324A", brand: "Madeira Polyneon" },
  { threadNumber: "1790", hexCode: "#736721", brand: "Madeira Polyneon" },
  { threadNumber: "1791", hexCode: "#A97A33", brand: "Madeira Polyneon" },
  { threadNumber: "1792", hexCode: "#A57D1C", brand: "Madeira Polyneon" },
  { threadNumber: "1793", hexCode: "#6A5921", brand: "Madeira Polyneon" },
  { threadNumber: "1794", hexCode: "#474523", brand: "Madeira Polyneon" },
  { threadNumber: "1795", hexCode: "#3B3E29", brand: "Madeira Polyneon" },
  { threadNumber: "1796", hexCode: "#535122", brand: "Madeira Polyneon" },
  { threadNumber: "1797", hexCode: "#00659C", brand: "Madeira Polyneon" },
  { threadNumber: "1798", hexCode: "#2A3024", brand: "Madeira Polyneon" },
  { threadNumber: "1799", hexCode: "#00B7A8", brand: "Madeira Polyneon" },
  { threadNumber: "1800", hexCode: "#202424", brand: "Madeira Polyneon" },
  { threadNumber: "1801", hexCode: "#E3E9FF", brand: "Madeira Polyneon" },
  { threadNumber: "1802", hexCode: "#EFF4FF", brand: "Madeira Polyneon" },
  { threadNumber: "1803", hexCode: "#FDFEF0", brand: "Madeira Polyneon" },
  { threadNumber: "1804", hexCode: "#FCFFFD", brand: "Madeira Polyneon" },
  { threadNumber: "1805", hexCode: "#D6DFFF", brand: "Madeira Polyneon" },
  { threadNumber: "1809", hexCode: "#B4A245", brand: "Madeira Polyneon" },
  { threadNumber: "1810", hexCode: "#B5BBB9", brand: "Madeira Polyneon" },
  { threadNumber: "1811", hexCode: "#ABB6B8", brand: "Madeira Polyneon" },
  { threadNumber: "1812", hexCode: "#ABAFA9", brand: "Madeira Polyneon" },
  { threadNumber: "1815", hexCode: "#FFCBE1", brand: "Madeira Polyneon" },
  { threadNumber: "1816", hexCode: "#FFB9CB", brand: "Madeira Polyneon" },
  { threadNumber: "1817", hexCode: "#FDB098", brand: "Madeira Polyneon" },
  { threadNumber: "1818", hexCode: "#ECCBC6", brand: "Madeira Polyneon" },
  { threadNumber: "1819", hexCode: "#FFA8A1", brand: "Madeira Polyneon" },
  { threadNumber: "1820", hexCode: "#F9967C", brand: "Madeira Polyneon" },
  { threadNumber: "1821", hexCode: "#9B3320", brand: "Madeira Polyneon" },
  { threadNumber: "1822", hexCode: "#EEEBD2", brand: "Madeira Polyneon" },
  { threadNumber: "1823", hexCode: "#F4FF00", brand: "Madeira Polyneon" },
  { threadNumber: "1824", hexCode: "#FFD400", brand: "Madeira Polyneon" },
  { threadNumber: "1825", hexCode: "#FB9400", brand: "Madeira Polyneon" },
  { threadNumber: "1826", hexCode: "#FFB95D", brand: "Madeira Polyneon" },
  { threadNumber: "1827", hexCode: "#61C1E8", brand: "Madeira Polyneon" },
  { threadNumber: "1828", hexCode: "#3D84AF", brand: "Madeira Polyneon" },
  { threadNumber: "1829", hexCode: "#2464A7", brand: "Madeira Polyneon" },
  { threadNumber: "1830", hexCode: "#6C8ECD", brand: "Madeira Polyneon" },
  { threadNumber: "1831", hexCode: "#9764A3", brand: "Madeira Polyneon" },
  { threadNumber: "1832", hexCode: "#5E4C96", brand: "Madeira Polyneon" },
  { threadNumber: "1833", hexCode: "#69256E", brand: "Madeira Polyneon" },
  { threadNumber: "1834", hexCode: "#9178A6", brand: "Madeira Polyneon" },
  { threadNumber: "1835", hexCode: "#722438", brand: "Madeira Polyneon" },
  { threadNumber: "1836", hexCode: "#3A2A27", brand: "Madeira Polyneon" },
  { threadNumber: "1837", hexCode: "#FF3B00", brand: "Madeira Polyneon" },
  { threadNumber: "1838", hexCode: "#9E1E1F", brand: "Madeira Polyneon" },
  { threadNumber: "1839", hexCode: "#991B1F", brand: "Madeira Polyneon" },
  { threadNumber: "1840", hexCode: "#697682", brand: "Madeira Polyneon" },
  { threadNumber: "1841", hexCode: "#3E4B50", brand: "Madeira Polyneon" },
  { threadNumber: "1842", hexCode: "#12509D", brand: "Madeira Polyneon" },
  { threadNumber: "1843", hexCode: "#173F74", brand: "Madeira Polyneon" },
  { threadNumber: "1844", hexCode: "#1F2631", brand: "Madeira Polyneon" },
  { threadNumber: "1845", hexCode: "#73CBA0", brand: "Madeira Polyneon" },
  { threadNumber: "1846", hexCode: "#008C8D", brand: "Madeira Polyneon" },
  { threadNumber: "1847", hexCode: "#44AA8F", brand: "Madeira Polyneon" },
  { threadNumber: "1848", hexCode: "#6C9948", brand: "Madeira Polyneon" },
  { threadNumber: "1849", hexCode: "#1F6E5A", brand: "Madeira Polyneon" },
  { threadNumber: "1850", hexCode: "#61CC39", brand: "Madeira Polyneon" },
  { threadNumber: "1851", hexCode: "#006F44", brand: "Madeira Polyneon" },
  { threadNumber: "1852", hexCode: "#2D738E", brand: "Madeira Polyneon" },
  { threadNumber: "1853", hexCode: "#F9CA9E", brand: "Madeira Polyneon" },
  { threadNumber: "1854", hexCode: "#977F79", brand: "Madeira Polyneon" },
  { threadNumber: "1855", hexCode: "#AF9368", brand: "Madeira Polyneon" },
  { threadNumber: "1856", hexCode: "#904B26", brand: "Madeira Polyneon" },
  { threadNumber: "1857", hexCode: "#764622", brand: "Madeira Polyneon" },
  { threadNumber: "1858", hexCode: "#592F22", brand: "Madeira Polyneon" },
  { threadNumber: "1859", hexCode: "#36302E", brand: "Madeira Polyneon" },
  { threadNumber: "1860", hexCode: "#A6A494", brand: "Madeira Polyneon" },
  { threadNumber: "1861", hexCode: "#FBDD76", brand: "Madeira Polyneon" },
  { threadNumber: "1862", hexCode: "#8E8E7F", brand: "Madeira Polyneon" },
  { threadNumber: "1863", hexCode: "#E2DEB6", brand: "Madeira Polyneon" },
  { threadNumber: "1866", hexCode: "#FFF18C", brand: "Madeira Polyneon" },
  { threadNumber: "1867", hexCode: "#D3FF3D", brand: "Madeira Polyneon" },
  { threadNumber: "1868", hexCode: "#00936A", brand: "Madeira Polyneon" },
  { threadNumber: "1869", hexCode: "#CC8F2E", brand: "Madeira Polyneon" },
  { threadNumber: "1870", hexCode: "#EDA75D", brand: "Madeira Polyneon" },
  { threadNumber: "1871", hexCode: "#7EB3D7", brand: "Madeira Polyneon" },
  { threadNumber: "1872", hexCode: "#504532", brand: "Madeira Polyneon" },
  { threadNumber: "1874", hexCode: "#96BBEB", brand: "Madeira Polyneon" },
  { threadNumber: "1878", hexCode: "#B92C17", brand: "Madeira Polyneon" },
  { threadNumber: "1879", hexCode: "#007060", brand: "Madeira Polyneon" },
  { threadNumber: "1880", hexCode: "#6B3580", brand: "Madeira Polyneon" },
  { threadNumber: "1882", hexCode: "#FFCEAD", brand: "Madeira Polyneon" },
  { threadNumber: "1883", hexCode: "#FFE600", brand: "Madeira Polyneon" },
  { threadNumber: "1884", hexCode: "#C9B28C", brand: "Madeira Polyneon" },
  { threadNumber: "1885", hexCode: "#9B7E5A", brand: "Madeira Polyneon" },
  { threadNumber: "1886", hexCode: "#C6C3C4", brand: "Madeira Polyneon" },
  { threadNumber: "1887", hexCode: "#37242C", brand: "Madeira Polyneon" },
  { threadNumber: "1888", hexCode: "#179CA1", brand: "Madeira Polyneon" },
  { threadNumber: "1890", hexCode: "#007377", brand: "Madeira Polyneon" },
  { threadNumber: "1891", hexCode: "#024D56", brand: "Madeira Polyneon" },
  { threadNumber: "1892", hexCode: "#7ED2D9", brand: "Madeira Polyneon" },
  { threadNumber: "1893", hexCode: "#4BB7D9", brand: "Madeira Polyneon" },
  { threadNumber: "1895", hexCode: "#028DAD", brand: "Madeira Polyneon" },
  { threadNumber: "1896", hexCode: "#006981", brand: "Madeira Polyneon" },
  { threadNumber: "1898", hexCode: "#8A4326", brand: "Madeira Polyneon" },
  { threadNumber: "1899", hexCode: "#7F321F", brand: "Madeira Polyneon" },
  { threadNumber: "1900", hexCode: "#9EBF9A", brand: "Madeira Polyneon" },
  { threadNumber: "1901", hexCode: "#5CAB15", brand: "Madeira Polyneon" },
  { threadNumber: "1902", hexCode: "#1F3B28", brand: "Madeira Polyneon" },
  { threadNumber: "1903", hexCode: "#304C3F", brand: "Madeira Polyneon" },
  { threadNumber: "1904", hexCode: "#384E3A", brand: "Madeira Polyneon" },
  { threadNumber: "1905", hexCode: "#2F3F27", brand: "Madeira Polyneon" },
  { threadNumber: "1906", hexCode: "#53482E", brand: "Madeira Polyneon" },
  { threadNumber: "1907", hexCode: "#FF3147", brand: "Madeira Polyneon" },
  { threadNumber: "1908", hexCode: "#FF2F43", brand: "Madeira Polyneon" },
  { threadNumber: "1909", hexCode: "#FF5D83", brand: "Madeira Polyneon" },
  { threadNumber: "1910", hexCode: "#C62048", brand: "Madeira Polyneon" },
  { threadNumber: "1911", hexCode: "#CDB7DC", brand: "Madeira Polyneon" },
  { threadNumber: "1915", hexCode: "#FFBBC0", brand: "Madeira Polyneon" },
  { threadNumber: "1917", hexCode: "#C77385", brand: "Madeira Polyneon" },
  { threadNumber: "1918", hexCode: "#858D8F", brand: "Madeira Polyneon" },
  { threadNumber: "1919", hexCode: "#954C5C", brand: "Madeira Polyneon" },
  { threadNumber: "1920", hexCode: "#D1CC88", brand: "Madeira Polyneon" },
  { threadNumber: "1921", hexCode: "#F89CC5", brand: "Madeira Polyneon" },
  { threadNumber: "1922", hexCode: "#432B76", brand: "Madeira Polyneon" },
  { threadNumber: "1923", hexCode: "#FF9E22", brand: "Madeira Polyneon" },
  { threadNumber: "1924", hexCode: "#FFDE00", brand: "Madeira Polyneon" },
  { threadNumber: "1925", hexCode: "#FFB400", brand: "Madeira Polyneon" },
  { threadNumber: "1926", hexCode: "#AA8665", brand: "Madeira Polyneon" },
  { threadNumber: "1927", hexCode: "#D9B28A", brand: "Madeira Polyneon" },
  { threadNumber: "1928", hexCode: "#7F725D", brand: "Madeira Polyneon" },
  { threadNumber: "1929", hexCode: "#5D5549", brand: "Madeira Polyneon" },
  { threadNumber: "1930", hexCode: "#414A95", brand: "Madeira Polyneon" },
  { threadNumber: "1931", hexCode: "#2D2C2C", brand: "Madeira Polyneon" },
  { threadNumber: "1932", hexCode: "#89CFF0", brand: "Madeira Polyneon" },
  { threadNumber: "1933", hexCode: "#7782B9", brand: "Madeira Polyneon" },
  { threadNumber: "1934", hexCode: "#015698", brand: "Madeira Polyneon" },
  { threadNumber: "1935", hexCode: "#DEFF00", brand: "Madeira Polyneon" },
  { threadNumber: "1936", hexCode: "#6B6455", brand: "Madeira Polyneon" },
  { threadNumber: "1937", hexCode: "#FF9000", brand: "Madeira Polyneon" },
  { threadNumber: "1938", hexCode: "#BBB09D", brand: "Madeira Polyneon" },
  { threadNumber: "1939", hexCode: "#928151", brand: "Madeira Polyneon" },
  { threadNumber: "1940", hexCode: "#CED33F", brand: "Madeira Polyneon" },
  { threadNumber: "1941", hexCode: "#B78C8C", brand: "Madeira Polyneon" },
  { threadNumber: "1942", hexCode: "#7D4C44", brand: "Madeira Polyneon" },
  { threadNumber: "1943", hexCode: "#5970B7", brand: "Madeira Polyneon" },
  { threadNumber: "1944", hexCode: "#1F2D3A", brand: "Madeira Polyneon" },
  { threadNumber: "1945", hexCode: "#604336", brand: "Madeira Polyneon" },
  { threadNumber: "1946", hexCode: "#FF5D00", brand: "Madeira Polyneon" },
  { threadNumber: "1947", hexCode: "#FF2F23", brand: "Madeira Polyneon" },
  { threadNumber: "1948", hexCode: "#FF91AA", brand: "Madeira Polyneon" },
  { threadNumber: "1949", hexCode: "#FFF9E2", brand: "Madeira Polyneon" },
  { threadNumber: "1950", hexCode: "#7EE020", brand: "Madeira Polyneon" },
  { threadNumber: "1951", hexCode: "#FFD578", brand: "Madeira Polyneon" },
  { threadNumber: "1952", hexCode: "#FD774E", brand: "Madeira Polyneon" },
  { threadNumber: "1953", hexCode: "#ABD1F1", brand: "Madeira Polyneon" },
  { threadNumber: "1954", hexCode: "#FF1F20", brand: "Madeira Polyneon" },
  { threadNumber: "1955", hexCode: "#F89C04", brand: "Madeira Polyneon" },
  { threadNumber: "1956", hexCode: "#827944", brand: "Madeira Polyneon" },
  { threadNumber: "1957", hexCode: "#393522", brand: "Madeira Polyneon" },
  { threadNumber: "1958", hexCode: "#593B38", brand: "Madeira Polyneon" },
  { threadNumber: "1959", hexCode: "#9E8700", brand: "Madeira Polyneon" },
  { threadNumber: "1960", hexCode: "#6C8DA5", brand: "Madeira Polyneon" },
  { threadNumber: "1961", hexCode: "#44637A", brand: "Madeira Polyneon" },
  { threadNumber: "1962", hexCode: "#183744", brand: "Madeira Polyneon" },
  { threadNumber: "1963", hexCode: "#39485F", brand: "Madeira Polyneon" },
  { threadNumber: "1964", hexCode: "#3F546C", brand: "Madeira Polyneon" },
  { threadNumber: "1965", hexCode: "#F16800", brand: "Madeira Polyneon" },
  { threadNumber: "1966", hexCode: "#1C2B4C", brand: "Madeira Polyneon" },
  { threadNumber: "1967", hexCode: "#182C48", brand: "Madeira Polyneon" },
  { threadNumber: "1968", hexCode: "#66934D", brand: "Madeira Polyneon" },
  { threadNumber: "1969", hexCode: "#5A5B46", brand: "Madeira Polyneon" },
  { threadNumber: "1970", hexCode: "#2A4F32", brand: "Madeira Polyneon" },
  { threadNumber: "1971", hexCode: "#FFC000", brand: "Madeira Polyneon" },
  { threadNumber: "1972", hexCode: "#FFB800", brand: "Madeira Polyneon" },
  { threadNumber: "1973", hexCode: "#875722", brand: "Madeira Polyneon" },
  { threadNumber: "1974", hexCode: "#7A3730", brand: "Madeira Polyneon" },
  { threadNumber: "1975", hexCode: "#224A6F", brand: "Madeira Polyneon" },
  { threadNumber: "1976", hexCode: "#1E2A39", brand: "Madeira Polyneon" },
  { threadNumber: "1977", hexCode: "#0080B4", brand: "Madeira Polyneon" },
  { threadNumber: "1978", hexCode: "#FF5C00", brand: "Madeira Polyneon" },
  { threadNumber: "1979", hexCode: "#00553A", brand: "Madeira Polyneon" },
  { threadNumber: "1980", hexCode: "#FFCF00", brand: "Madeira Polyneon" },
  { threadNumber: "1981", hexCode: "#72212A", brand: "Madeira Polyneon" },
  { threadNumber: "1982", hexCode: "#721E22", brand: "Madeira Polyneon" },
  { threadNumber: "1983", hexCode: "#3C2835", brand: "Madeira Polyneon" },
  { threadNumber: "1984", hexCode: "#A82853", brand: "Madeira Polyneon" },
  { threadNumber: "1985", hexCode: "#004C3F", brand: "Madeira Polyneon" },
  { threadNumber: "1986", hexCode: "#A11F39", brand: "Madeira Polyneon" },
  { threadNumber: "1987", hexCode: "#D73706", brand: "Madeira Polyneon" },
  { threadNumber: "1988", hexCode: "#16893A", brand: "Madeira Polyneon" },
  { threadNumber: "1989", hexCode: "#19985B", brand: "Madeira Polyneon" },
  { threadNumber: "1990", hexCode: "#D35791", brand: "Madeira Polyneon" },
  { threadNumber: "1991", hexCode: "#006A75", brand: "Madeira Polyneon" },
  { threadNumber: "1992", hexCode: "#005569", brand: "Madeira Polyneon" },
  { threadNumber: "1993", hexCode: "#D13353", brand: "Madeira Polyneon" },
  { threadNumber: "1994", hexCode: "#E34460", brand: "Madeira Polyneon" },
  { threadNumber: "1995", hexCode: "#FFFA00", brand: "Madeira Polyneon" },
  { threadNumber: "1996", hexCode: "#1F3531", brand: "Madeira Polyneon" },
  { threadNumber: "1997", hexCode: "#27232D", brand: "Madeira Polyneon" },
  { threadNumber: "1998", hexCode: "#71575B", brand: "Madeira Polyneon" },
  { threadNumber: "1999", hexCode: "#552723", brand: "Madeira Polyneon" },
  { threadNumber: "2800", hexCode: "#202523", brand: "Madeira Polyneon" },
];



